<template>
    <div>
        <e-dialog
                dialog-title="提示"
                :center-dialog-visible="sameIpTip"
                popup-width="400px"
                :closeBtn="true"
                @resetPopupData="handleClose"
                @submitPopupData="handleClose"
        >
            尊敬的用户，您好！在操作订单时，系统检测到您与采购商的IP地址相同。
            根据平台规定，供应商与采购商需使用不同的IP地址进行操作，以确保交易安全和数据的准确性。
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';

export default {
  components: {
    eDialog,
  },
  props: {
    sameIpTip: Boolean,
  },
  methods: {
    handleClose() {
      this.$emit('update:sameIpTip', false);
    },
  },
};
</script>

<style scoped></style>
